import { cn } from '@/lib/utils';

/**
 * Logos are shown exactly as supplied, colors never altered. On dark surfaces they
 * sit on a white rounded panel instead of being recolored.
 */
function LogoPanel({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <span className={cn('inline-flex items-center rounded-md dark:bg-white dark:px-2 dark:py-1', className)}>
      {children}
    </span>
  );
}

export function BlackWolfLogo({ className }: { className?: string }) {
  return (
    <LogoPanel className={className}>
      <img src="/brand/blackwolf-solutions.png" alt="BlackWolf Solutions" className="h-7 w-auto" />
    </LogoPanel>
  );
}

export function ClientLogo({
  programId,
  version,
  clientName,
  className,
  imgClassName,
}: {
  programId: string;
  version: number;
  clientName: string;
  className?: string;
  imgClassName?: string;
}) {
  return (
    <LogoPanel className={cn('bg-white px-1.5 py-0.5', className)}>
      <img
        src={`/api/programs/${programId}/logo?v=${version}`}
        alt={clientName}
        className={cn('h-9 w-auto', imgClassName)}
      />
    </LogoPanel>
  );
}

/**
 * The HELM logo (docs/brand/helm-logo-master.png): navy for light surfaces, white with a
 * blue wheel for dark. "compact" drops the "by BlackWolf Solutions" line for small sizes.
 */
export function HelmWordmark({ className, variant = 'compact' }: { className?: string; variant?: 'compact' | 'full' }) {
  const name = variant === 'compact' ? 'helm-compact' : 'helm-logo';
  const size = variant === 'compact' ? 'h-8' : 'h-32';
  return (
    <span className={cn('inline-flex items-center', className)}>
      <img
        src={`/brand/${name}-light.png`}
        alt="HELM by BlackWolf Solutions"
        className={cn(size, 'w-auto dark:hidden')}
      />
      <img
        src={`/brand/${name}-dark.png`}
        alt="HELM by BlackWolf Solutions"
        className={cn(size, 'hidden w-auto dark:block')}
      />
    </span>
  );
}
